import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useState, useContext, useEffect } from 'react';
import AuthContext from '../context/AuthContext';

const baseUrl = '  https://erp.mgmebuild.com/api/';

function Copyright(props: any) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <Link color="inherit" href="http://www.mgmebuild.com/">
             MGM eBuild Pvt Ltd
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}
function Login(props) {
  const [formError, setFormError] = useState(false);
  const { loginUser } = useContext(AuthContext);
  const [errorMsg, seterrorMsg] = useState('');
  const [loginData, setloginData] = useState({
    username: '',
    password: '',
  });
  const [isLicenseExpired, setIsLicenseExpired] = useState(false); // New state for license expiry
  const inputHandler = (event) => {
    setloginData({
      ...loginData,
      [event.target.name]: event.target.value,
    });
  };

  const buttonEnable = loginData.mobile !== '' && loginData.password !== '';

  const handleSubmit = (event) => {
    event.preventDefault();
    loginUser(event);
  };
  useEffect(() => {
    const licenseExpiryDate = new Date("2026-12-31"); // License expiry date
    const today = new Date();

    if (today > licenseExpiryDate) {
      setIsLicenseExpired(true); // Set the license expired state to true
    }
  }, []);
// TODO remove, this demo shouldn't need to reset the theme.
const defaultTheme = createTheme();


  return (
    <ThemeProvider theme={defaultTheme}>
      <Grid container component="main" sx={{ height: '100vh' }}>
        <CssBaseline />
        <Grid
          item
          xs={false}
          sm={4}
          md={7}
          sx={{
            backgroundImage: 'url(/mgmerp.png)',
            backgroundRepeat: 'no-repeat',
            backgroundColor: (t) =>
              t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900],
            backgroundSize: 'contain',   // ✅ keeps full image
            backgroundPosition: 'center',
          }}
        />
        <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
          <Box
            sx={{
              my: 8,
              mx: 4,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <Avatar sx={{ m: 2, bgcolor: 'white' }}>
              <img src="/mgm.png" />
            </Avatar>
            <Typography component="h1" variant="h5">
              Sign in
            </Typography>
             {isLicenseExpired ? (
              <Typography color="error" variant="body2" align="center" sx={{ mt: 2 }}>
                Your license has expired. Please contact support.
              </Typography>
            ) : (
              formError && <p className="text-danger">{errorMsg}</p>
            )}
             <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 1 }}>
              <TextField
                margin="normal"
                required
                fullWidth
                id="username"
                label="User Name"
                name="username"
                autoComplete="username"
                value={loginData.username}
                onChange={inputHandler}
                autoFocus
                disabled={isLicenseExpired}
              />
              <TextField
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                value={loginData.password}
                onChange={inputHandler}
                disabled={isLicenseExpired}
              />

                <Button
                type="submit"
                fullWidth
                variant="contained"
                color="success"
                disabled={!buttonEnable || isLicenseExpired}
                sx={{ mt: 3, mb: 2 }}
              >
                Submit
              </Button>

              <Copyright sx={{ mt: 5 }} />
            </Box>
          </Box>
        </Grid>
      </Grid>
    </ThemeProvider>
  );
}
export default Login;
